module.exports = __webpack_public_path__ + "img/un.un59939c4.svg";